module.exports = __webpack_public_path__ + "static/media/reportdata.09628635.png";